import { render, staticRenderFns } from "./RequestJudgement.vue?vue&type=template&id=9508cfdc"
import script from "./RequestJudgement.vue?vue&type=script&lang=js"
export * from "./RequestJudgement.vue?vue&type=script&lang=js"
import style0 from "./RequestJudgement.vue?vue&type=style&index=0&id=9508cfdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports